function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import localeKeys from '../../../../locales/keys';
import { REGEXES, NOTIFICATION_TIME_LENGTH } from '../../../../customercare.constants';
import { i18n } from 'invision-core';
import { resendRedemptionCode } from '../../../../reducers/actions/customer.coupons.actions';
import { CurrentCustomerIdSelector } from '../../../../reducers/selectors/customer.selectors';
var ResendRedemptionPopupController = /*#__PURE__*/function () {
  function ResendRedemptionPopupController($ngRedux, uiNotificationService) {
    _classCallCheck(this, ResendRedemptionPopupController);
    this.localeKeys = localeKeys;
    this.$ngRedux = $ngRedux;
    this.uiNotificationService = uiNotificationService;
    this.vm = {
      errorMessages: [],
      emailRegex: REGEXES.EMAIL,
      isLoading: false,
      isResendingCode: false
    };
  }
  return _createClass(ResendRedemptionPopupController, [{
    key: "handleClose",
    value: function handleClose() {
      this.onClose()();
    }
  }, {
    key: "handleSubmitForm",
    value: function handleSubmitForm() {
      var _this = this;
      if (this.resendRedemptionPopupForm.$invalid) {
        return;
      }
      this.vm.isLoading = true;
      this.actions.resendRedemptionCode(this.state.currentCustomerId, this.redemptionDetails.RedemptionCode.RedemptionCode, this.vm.resendRedemptionCodeModel.ResendCouponCodeEmail, this.vm.resendRedemptionCodeModel.ResendCouponCodeRecipient).then(function () {
        _this.uiNotificationService.success(i18n.translate(_this.localeKeys.COUPONS.REDEMPTION_CODE_DETAILS.LABELS.RESEND_SUCCESS_MESSAGE), null, {
          timeOut: NOTIFICATION_TIME_LENGTH
        });
        _this.onClose()(true);
      }).catch(function (error) {
        _this.onClose()(false, error);
      }).finally(function () {
        _this.vm.isLoading = false;
      });
    }
  }, {
    key: "$onInit",
    value: function $onInit() {
      var _this2 = this;
      var controllerActions = {
        resendRedemptionCode: resendRedemptionCode
      };
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          currentCustomerId: CurrentCustomerIdSelector(store)
        };
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this2.state = state;
        _this2.actions = actions;
      });
      this.vm.resendRedemptionCodeModel = {
        // TODO Email does not get returned from the API.  Speak with Sanjay about this.
        ResendCouponCodeEmail: this.redemptionDetails.RedemptionCode.SubscriberEmail,
        ResendCouponCodeRecipient: this.redemptionDetails.RedemptionCode.SubscriberName
      };
    }
  }, {
    key: "$onChanges",
    value: function $onChanges(changesObj) {
      if (changesObj.redemptionDetails.currentValue) {
        this.vm.dialogHeading = i18n.translate(this.localeKeys.COUPONS.RESEND_REDEMPTION_CODE.DIALOG_HEADING, {
          couponName: changesObj.redemptionDetails.currentValue.Coupon.Name
        });
      }
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnectRedux();
    }
  }]);
}();
export default {
  template: require('./resend.redemption.code.popup.html'),
  bindings: {
    redemptionDetails: '<',
    onClose: '&'
  },
  controller: ResendRedemptionPopupController
};